import { IRiskSupplementWarningTypeResponseDTO } from '@interfaces/highRiskSupplements';

export class RiskSupplementWarningType {
  id: number;

  name: string;

  normalizedName: string;

  description: string;

  descriptionFragments: string[];

  constructor(dto: IRiskSupplementWarningTypeResponseDTO) {
    const data: IRiskSupplementWarningTypeResponseDTO =
      dto && typeof dto === 'object' ? dto : ({} as IRiskSupplementWarningTypeResponseDTO);
    this.id = data.id as number;
    this.name = typeof data.name === 'string' ? data.name : '';
    this.normalizedName = this.name.toLowerCase().replaceAll(' ', '');
    this.description = typeof data.description === 'string' ? data.description : '';
    this.descriptionFragments = this.description.split('.').reduce((prev, item) => {
      const sentence = item.trim();
      if (sentence) {
        prev.push(`${sentence}.`);
      }
      return prev;
    }, [] as string[]);
  }
}
